<template>
    <div class="input-group">
        <slot name="prepend"></slot>
        <input
            :value="value"
            :type="visible ? 'text' : 'password'"
            :class="inputClasses"
            :placeholder="placeholder"
            :minlength="minlength"
            :maxlength="maxlength"
            :required="required"
            :aria-label="ariaLabel || placeholder"
            :aria-describedby="ariaDescribedby"
            @input="$emit('input', $event.target.value)"
        />
        <div class="input-group-append">
            <button
                type="button"
                class="btn btn-outline-secondary"
                tabindex="-1"
                @click="visible = !visible"
            >
                <i :class="visible ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
            </button>
        </div>
        <slot name="feedback"></slot>
    </div>
</template>

<script>
export default {
    name: 'PasswordToggleInput',
    props: {
        value: { type: String, default: '' },
        placeholder: { type: String, default: 'Password' },
        hasError: { type: Boolean, default: false },
        minlength: { type: [String, Number], default: null },
        maxlength: { type: [String, Number], default: null },
        required: { type: Boolean, default: false },
        ariaLabel: { type: String, default: null },
        ariaDescribedby: { type: String, default: null },
        autocomplete: { type: String, default: null },
    },
    emits: ['input'],
    data() {
        return { visible: false };
    },
    computed: {
        inputClasses() {
            return ['form-control', this.hasError ? 'is-invalid' : ''];
        },
    },
};
</script>
